import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_InformationDialog extends MatDialogDataBaseInput {
	title: string;
	description: string;
	okText: string;
}

export interface DialogData_InformationDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-information-dialog",
	templateUrl: "./information-dialog.component.html",
	styleUrls: ["./information-dialog.component.scss"],
	standalone: false,
})
export class InformationDialogComponent extends BasicMaterialDialog<
	InformationDialogComponent,
	DialogData_InformationDialog,
	DialogData_InformationDialogOutput
> {
	constructor(_injector: Injector) {
		super(_injector);
	}
}
